import React from 'react'
import { Styles } from 'react-select/lib/styles'
import { IndicatorProps } from 'react-select/lib/components/indicators'
import { fieldStatusAppearence } from '../sheet'

export const colourStyles: Styles = {
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  //@ts-ignore
  control: (styles, state) => {
    const isFocused = state.isFocused ? fieldStatusAppearence.focused : {}
    const isDisabled = state.isDisabled ? { opacity: 0.5 } : {}
    return {
      ...styles,
      display: 'flex',
      minWidth: 100,
      width: '100%',
      minHeight: 49,
      height: 49,
      padding: '0 15px',
      ...fieldStatusAppearence.text,
      ...fieldStatusAppearence.base,
      ...isFocused,
      ...isDisabled,
      boxShadow: 'none',
      '&:hover': {
        borderColor: 'none'
      },
      '&:focused': {
        ...fieldStatusAppearence.focused
      }
    }
  },
  placeholder: (styles, state) => ({
    ...styles,
    color: '#94A3B8',
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontStyle: 'normal',
    fontSize: '14.25px',
    lineHeight: '21.38px',
    letterSpacing: '0px'
  }),
  input: styles => {
    return {
      ...styles,
      letterSpacing: '0.01em',
      border: 'none',
      maxWidth: 100,
      padding: 'none',
      ...fieldStatusAppearence.text
    }
  },
  menu: styles => {
    return {
      ...styles,
      backgroundColor: '#FFFFFF',
      borderRadius: 'unset',
      boxShadow: '0px 2px 9px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.08)',
      zIndex: 9999
    }
  },
  menuList: styles => {
    return {
      ...styles,
      maxHeight: '200px',
      overflowY: 'auto'
    }
  },
  option: (styles, { isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? '#EEE' : undefined,
      lineHeight: '20px',
      fontSize: 15,
      letterSpacing: '0.01em',
      color: '#080910'
    }
  },
  singleValue: styles => {
    return {
      ...styles,
      color: '#080910',
      fontWeight: 'normal',
      lineHeight: '20px',
      fontSize: '15px',
      letterSpacing: '0.01em',
      border: 'none'
    }
  },
  valueContainer: styles => {
    return { ...styles, border: 'none', padding: 0 }
  },
  indicatorSeparator: styles => {
    return {
      ...styles,
      display: 'none'
    }
  }
}
export const colourStylesWithoutBorder: Styles = {
  ...colourStyles,
  control: (styles, state) => {
    return {
      ...styles,
      border: 'none',
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      borderBottomColor: state.theme.colors.neutral10,
      borderRadius: 'none',
      boxShadow: 'none'
    }
  }
}

export const DropdownIndicator = (
  state: IndicatorProps<{ value: string | number; label: string | number }>
) => {
  return state.isFocused ? (
    <div
      style={{
        width: 0,
        height: 0,
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent',
        borderBottom: '6px solid #080910',
        // margin: '0 10px',
        transition: 'all .2s ease'
      }}
    />
  ) : (
    <div
      style={{
        width: 0,
        height: 0,
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent',
        borderTop: '6px solid #080910',
        // margin: '0 10px',
        transition: 'all .2s ease'
      }}
    />
  )
}
